export function foo() {
  console.log("I am foo");
}
